<!-- ── Breadcrumb Strip ────────────────────────────────────────────────────── -->
<div class="pd-page-strip">
  <div class="container">
    <nav class="pd-breadcrumb">
      <a routerLink="/home" class="crumb">{{ 'nav.home' | translate }}</a>
      <span class="crumb-sep">·</span>
      <a routerLink="/shop" class="crumb">{{ 'nav.shop' | translate }}</a>
      <span class="crumb-sep">·</span>
      <span class="crumb crumb--active">{{ prodName }}</span>
    </nav>
  </div>
</div>

<!-- ── Main Product Card ──────────────────────────────────────────────────── -->
<section class="pd-section">
  <div class="container">
    <div class="pd-card">
      <div class="row g-0">

        <!-- Gallery -->
        <div class="col-12 col-md-6">
          <div class="pd-gallery" [class.pd-gallery--portrait]="isPortrait">
            <swiper [config]="config" dir="ltr">
              <ng-template swiperSlide *ngFor="let item of mainImages_arr; let i = index">
                <div class="pd-slide">
                  <img [src]="item.image_url" [alt]="prodName"
                       (load)="i === 0 ? onImageLoaded($event) : null" />
                </div>
              </ng-template>
            </swiper>
          </div>
        </div>

        <!-- Info panel -->
        <div class="col-12 col-md-6">
          <div class="pd-info">

            <div class="pd-eyebrow">
              <span class="pd-eyebrow-rule"></span>
              <span>{{ 'prod.collection' | translate }}</span>
              <span class="pd-eyebrow-rule"></span>
            </div>

            <h1 class="pd-name">{{ prodName }}</h1>

            <div class="pd-stars" *ngIf="rateArr.length > 0">
              <i class="ti-star" *ngFor="let item of rateArr"></i>
            </div>

            <div class="pd-divider"></div>

            <div class="pd-price-group">
              <div class="pd-price-meta" *ngIf="discount > 0">
                <span class="pd-price-was">LE {{ prodPrice }}</span>
                <span class="pd-price-badge">{{ discount }}% OFF</span>
              </div>
              <p class="pd-price">{{ displayPrice }} <span>LE</span></p>
            </div>

            <strong *ngIf="stock == 0" class="pd-notice">
              <i class="ti-time"></i>
              {{ 'prod.delivery_note' | translate }}
            </strong>

            <!-- Variants -->
            <div class="pd-variants" *ngIf="variants.length > 0">
              <p class="pd-variants-label">{{ variants[0]?.name }}</p>
              <div class="pd-variants-list">
                <button
                  *ngFor="let v of variants"
                  class="pd-variant-btn"
                  [class.selected]="selectedVariant?.id === v.id"
                  (click)="selectVariant(v)"
                >
                  {{ v.value }}
                  <span *ngIf="v.price_modifier > 0"> +{{ v.price_modifier }} LE</span>
                  <span *ngIf="v.price_modifier < 0"> {{ v.price_modifier }} LE</span>
                </button>
              </div>
            </div>

            <div class="pd-qty-row">
              <div class="pd-qty">
                <button class="pd-qty-btn" (click)="minus()">−</button>
                <span class="pd-qty-val">{{ count }}</span>
                <button class="pd-qty-btn" (click)="plus()">+</button>
              </div>
              <button class="pd-add-btn" (click)="addToCart()">{{ 'prod.add_cart' | translate }}</button>
              <button class="pd-wish-btn" (click)="toggleWishlist()" [class.active]="inWishlist" [title]="(inWishlist ? 'prod.wishlist_remove' : 'prod.wishlist_add') | translate">
                <i class="ti-heart"></i>
              </button>
            </div>

          </div>
        </div>

      </div>
    </div>

    <!-- Description -->
    <div class="pd-desc-section">
      <h3 class="pd-desc-title">{{ 'prod.desc_title' | translate }}</h3>
      <ul class="pd-desc-list">
        <li *ngFor="let item of description">{{ item }}</li>
      </ul>
    </div>
  </div>
</section>

<!-- ── Screenshots ────────────────────────────────────────────────────────── -->
<section class="pd-extra-section" *ngIf="screenShootImage.length != 0">
  <div class="container">
    <div class="pd-section-label">
      <span class="pd-label-rule"></span>
      <h3>{{ 'prod.screenshots' | translate }}</h3>
      <span class="pd-label-rule"></span>
    </div>
    <div class="row g-3">
      <div class="col-12 col-md-4" *ngFor="let item of screenShootImage">
        <div class="pd-screenshot-card">
          <img [src]="item.image_url" [alt]="prodName" />
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ── Videos ─────────────────────────────────────────────────────────────── -->
<section class="pd-extra-section" *ngIf="videos_arr.length != 0">
  <div class="container">
    <div class="pd-section-label">
      <span class="pd-label-rule"></span>
      <h3>{{ 'prod.videos' | translate }}</h3>
      <span class="pd-label-rule"></span>
    </div>
    <div class="row g-3">
      <div class="col-12 col-md-6" *ngFor="let item of videos_arr">
        <video class="pd-video" controls>
          <source [src]="item.image_url" type="video/mp4" />
          <source [src]="item.image_url" type="video/ogg" />
        </video>
      </div>
    </div>
  </div>
</section>

<!-- ── Reviews ────────────────────────────────────────────────────────────── -->
<section class="pd-reviews-section">
  <div class="container">
    <div class="pd-section-label">
      <span class="pd-label-rule"></span>
      <h3>
        {{ 'prod.reviews' | translate }}
        <span class="pd-review-count" *ngIf="reviews.length > 0">({{ reviews.length }})</span>
      </h3>
      <span class="pd-label-rule"></span>
    </div>

    <!-- Review list -->
    <div class="pd-reviews" *ngIf="reviews.length > 0">
      <div class="pd-review-item" *ngFor="let item of reviews">
        <div class="pd-review-avatar">
          {{ (item.client || '?').charAt(0).toUpperCase() }}
        </div>
        <div class="pd-review-body">
          <div class="pd-review-header">
            <span class="pd-reviewer-name">{{ item.client }}</span>
            <span class="pd-review-date">{{ item.joined_date | date: "yyyy/MM/dd" }}</span>
          </div>
          <div class="pd-stars pd-stars--sm">
            <i class="ti-star" *ngFor="let rate of item.arr"></i>
          </div>
          <p class="pd-review-text">{{ item.review }}</p>
        </div>
      </div>
    </div>

    <p class="pd-no-reviews" *ngIf="reviews.length === 0">{{ 'prod.no_reviews' | translate }}</p>

    <!-- Add review form -->
    <div class="pd-add-review" *ngIf="clientID">
      <h4 class="pd-add-title">{{ 'prod.review_leave' | translate }}</h4>
      <p class="pd-add-sub">{{ 'prod.review_rating' | translate }}</p>

      <div class="pd-rate-group">
        <div class="pd-rate-option" (click)="goActiveRate('1')">
          <a [ngClass]="activeRate && rateId == '1' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
        </div>
        <div class="pd-rate-option" (click)="goActiveRate('2')">
          <a [ngClass]="activeRate && rateId == '2' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
          <a [ngClass]="activeRate && rateId == '2' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
        </div>
        <div class="pd-rate-option" (click)="goActiveRate('3')">
          <a [ngClass]="activeRate && rateId == '3' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
          <a [ngClass]="activeRate && rateId == '3' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
          <a [ngClass]="activeRate && rateId == '3' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
        </div>
        <div class="pd-rate-option" (click)="goActiveRate('4')">
          <a [ngClass]="activeRate && rateId == '4' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
          <a [ngClass]="activeRate && rateId == '4' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
          <a [ngClass]="activeRate && rateId == '4' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
          <a [ngClass]="activeRate && rateId == '4' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
        </div>
        <div class="pd-rate-option" (click)="goActiveRate('5')">
          <a [ngClass]="activeRate && rateId == '5' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
          <a [ngClass]="activeRate && rateId == '5' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
          <a [ngClass]="activeRate && rateId == '5' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
          <a [ngClass]="activeRate && rateId == '5' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
          <a [ngClass]="activeRate && rateId == '5' ? 'activeRate' : 'dot'"><i class="ti-star"></i></a>
        </div>
      </div>

      <div class="pd-review-field">
        <label>{{ 'prod.review_label' | translate }}</label>
        <textarea [(ngModel)]="textArea" class="pd-textarea" rows="4" [placeholder]="'prod.review_placeholder' | translate"></textarea>
      </div>

      <button class="pd-submit-btn" (click)="addReview()">{{ 'prod.submit_review' | translate }}</button>
    </div>

  </div>
</section>
